import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'
import app from './app'
import polls from './polls'
import results from './results'
import user from './user'
import vote from './vote'
import types from '../actions/types'

const appReducer = combineReducers({
	app,
	polls,
	results,
	routing,
	user,
	vote,
})

export default (state, action) => {
	if ([types.SIGN_OUT, types.USER_UPDATED].includes(action.type)) {
		return appReducer(undefined, action)
	}

	return appReducer(state, action)
}



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js